















































import { ref, defineComponent, useContext } from '@nuxtjs/composition-api'
import Link from '../components/Link.vue'
import { FormInputType } from '@/contracts/FormInputType'
import { FormMask } from '@/contracts/FormMask'
import { sectionCoreProps } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import FormGenerator from '@/components/FormGenerator.vue'
import useLogUserAgreement from '@/composition/useLogUserAgreement'
import useSendMcOrmEvent from '@/composition/useSendMcOrmEvent'

export default defineComponent({
  name: 'SectionCheckDocuments',
  components: {
    Link,
    SectionBasic,
    FormGenerator,
  },
  mixins: [sectionCoreProps],
  setup() {
    const { $api } = useContext()
    const pageStages = ref({
      start: 'start',
      submitSuccess: 'submitSuccess',
    })
    const pageStage = ref<string>('start')
    const loading = ref(false)
    const isFormSend = ref<boolean>(false)
    const forms = ref<any>([
      {
        id: 'userName',
        type: FormInputType.Text,
        label: 'Ваши ФИО',
        formKey: '',
        placeholder: 'Например, Иванов Иван Иванович',
        mask: FormMask.NotSet,
        field: 'InputText',
        rules: ['required', 'fullName'],
      },
      {
        id: 'email',
        type: FormInputType.Text,
        label: 'Электронная почта',
        formKey: '',
        placeholder: 'example@mail.ru',
        mask: FormMask.NotSet,
        field: 'InputText',
        rules: ['required', 'email'],
      },
      {
        id: 'documentList',
        type: FormInputType.Text,
        label: 'Перечислите документы по страховому случаю, которые у вас есть',
        formKey: '',
        placeholder: 'Справка о ДТП, фотофиксация и т.д.',
        mask: FormMask.NotSet,
        field: 'InputText',
        rules: [],
      },
      {
        id: 'inputFile',
        type: 'file',
        label: 'Прикрепите документ, описывающий суть обращения',
        formKey: '',
        accept: 'application/pdf, image/jpeg, image/png',
        placeholder:
          '<span class="red-text">Выберите файл</span> <span>или перенесите его в эту область</span>',
        class: 'input-file',
        mask: FormMask.NotSet,
        field: 'InputFile',
        rules: ['file'],
      },
      {
        id: 'accept',
        formKey: 'Политика конфиденциальности',
        field: 'InputAccept',
        rules: ['accept'],
        title: 'Я соглашаюсь с',
        link: {
          url: '/about/politika-o-poryadke-obrabotki-personalnykh-dannykh',
          label: 'условиями обработки персональных данных',
        },
        dynamicContent: 'BlockAcceptMessage',
      },
    ])
    const formData = ref<any>({
      forms,
      btnLabel: 'Запросить документы',
    })
    const report = ref({
      message: 'Мы отправили информацию о документах на ваш электронный адрес',
      emailRecipient: 'example@email.ru',
    })
    const resumeBtn = ref([
      {
        innerText: 'Перейти на главную',
        linkUrl: '/',
      },
      {
        innerText: 'Запросить еще раз',
      },
    ])

    const logUserAgreement = useLogUserAgreement()
    const sendMcOrmEvent = useSendMcOrmEvent()

    const onSubmit = async (event) => {
      loading.value = true
      const { email } = event
      const params = {
        email,
      }
      const { data } = await $api.requests.checkDocuments(params)

      if (data?.status === 200) {
        report.value.emailRecipient = email
      }

      logUserAgreement({
        email: event.email,
        agreement: event.accept,
      })

      const formFields = {
        ...params,
        userName: event.userName,
        agreement: event.accept,
        documentList: event.documentList,
      }
      delete formFields.inputFile

      sendMcOrmEvent({ fields: formFields, files: params.inputFile })

      isFormSend.value = true
      pageStage.value = pageStages.value.submitSuccess
      loading.value = false
    }

    const startNew = () => {
      isFormSend.value = false
      pageStage.value = pageStages.value.start
    }

    return {
      loading,
      isFormSend,
      pageStages,
      pageStage,
      formData,
      report,
      resumeBtn,
      onSubmit,
      startNew,
    }
  },
})
